export default "__VITE_ASSET__FS42G8sY__"